import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=1bd10f70&scoped=true&"
import script from "./Animation.vue?vue&type=script&lang=js&"
export * from "./Animation.vue?vue&type=script&lang=js&"
import style0 from "./Animation.vue?vue&type=style&index=0&id=1bd10f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd10f70",
  null
  
)

export default component.exports